import React from "react";
import NumberFormat from "react-number-format";

const Input = ({
  name,
  label,
  type = "text",
  format = "text",
  error,
  value,
  onValueChange,
  ...rest
}) => {
  return (
    <div className="form-group" style={{ marginBottom: "0px" }}>
      {label && <label htmlFor={name}>{label}</label>}
      {format === "text" && (
        <input
          {...rest}
          value={value}
          name={name}
          className="form-control"
          type={type}
          id={name}
          autoComplete="off"
        />
      )}
      {format === "number" && (
        <NumberFormat
          decimalScale={0}
          value={value}
          displayType={"text"}
          thousandSeparator={true}
          renderText={(val) => (
            <input
              {...rest}
              name={name}
              className="form-control"
              type={type}
              id={name}
              value={val}
              autoComplete="off"
            />
          )}
        />
      )}
      {format === "decimal" && (
        <NumberFormat
          {...rest}
          onValueChange={onValueChange}
          value={value}
          name={name}
          className="form-control"
          thousandSeparator={true}
          autoComplete="off"
        />
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Common/input.jsx